import { Component, inject, OnInit } from '@angular/core';
import { AllIconsComponent } from "../../../domain/shared/component/all-icons/all-icons.component";
import { ORCA_HELP_MAIL } from "../../../util/common/links";
import { ShowUIService } from "../../service/show-ui.service";

@Component({
  selector: 'app-ban',
  imports: [
    AllIconsComponent,
  ],
  templateUrl: './ban.component.html',
  styleUrl: './ban.component.scss',
  standalone: true,
})
export class BanComponent {
  private showUIService = inject(ShowUIService);
  supportEmail = ORCA_HELP_MAIL;

  constructor() {
    this.showUIService.setShowHorNavBar(false);
    this.showUIService.setShowSideNavBar(false);
  }
}
